import {useEffect} from 'react';
import classNames from 'classnames';

import {useSpring, animated} from 'react-spring';
import SETTINGS from '../settings';

import log from 'loglevel';

import {FA} from '../utils/font-awesome';

const ValueUnit = React.memo(props => {
  const isRound = props.value == Math.round(props.value);
  const valueSpring = useSpring({config:{...SETTINGS.ANIMATION, velocity:0}, value:parseFloat(props.value)});
  return <div className="value">
          <animated.span>{valueSpring.value.interpolate(x => {
            return isRound ? Math.round(x).toLocaleString() : x.toFixed(2)
          })}</animated.span>
          {props.unit && <span className="unit">{props.unit}</span>}
        </div>
});

const LargeCard = props => {
  useEffect(() => {
    props.onClick && props.id && props.onClick(props.id, true);
  }, [props.value]);
  const extra = props.extra ? <div className="extra">{props.extra}</div> : <></>;
  return (
  <div className="card">
    <div className={classNames("card-section", "large-" + props.type || 'number', {clickable:props.clickable})} onClick={() => props.onClick && props.onClick(props.id)}>
      <div className="label">
        <span>{props.title}</span>
        {props.hasOwnProperty('checked') && <FA icon={props.checked ? "eye" : "eye-slash"}/>}
      </div>
      <ValueUnit value={props.value || 0} unit={props.unit} />
      {extra}
    </div>
  </div>
  );
};

export default React.memo(LargeCard);
